module.exports = __webpack_public_path__ + "img/champions.656fc440.svg";